// extracted by mini-css-extract-plugin
module.exports = {"PrincipalPage":"HomePage_PrincipalPage__2By_N"};